var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZunuMailIconInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3940_86836)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.7354 0H33.1644C15.0812 0 0.421875 14.6593 0.421875 32.7425V87.3135C0.421875 105.397 15.0812 120.056 33.1644 120.056H87.7354C105.819 120.056 120.478 105.397 120.478 87.3135V32.7425C120.478 14.6593 105.819 0 87.7354 0Z",
    fill: "#9C9B9B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3940_86836",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 30,
    width: 77,
    height: 62
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6491 30.0156H22.25V91.4078H98.6491V30.0156Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3940_86836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.4119 32.7422H34.4872C27.7288 32.7422 22.25 38.221 22.25 44.9794V79.1686C22.25 85.927 27.7288 91.4058 34.4872 91.4058H86.4119C93.1703 91.4058 98.6491 85.927 98.6491 79.1686V44.9794C98.6491 38.221 93.1703 32.7422 86.4119 32.7422Z",
    fill: "#BABDBB"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.4136 44.1497C20.2231 39.1829 24.541 28.6562 33.2802 28.6562H88.4552C96.7953 28.6562 100.486 39.0897 93.8564 44.1497C85.8163 50.2862 74.6733 58.1487 67.4413 63.1863C63.1073 66.2052 57.329 66.0559 53.1071 62.8822C46.1538 57.6554 35.4358 49.6909 27.4136 44.1497Z",
    fill: "#E3E4E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3940_86836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 121,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZunuMailIconInactive);
export default __webpack_public_path__ + "static/media/zunu_mail_icon_inactive.0b40b46d926950917797cb4fe7c72ec8.svg";
export { ForwardRef as ReactComponent };